import { Box, Button, Chip, Divider, Grid, Typography } from '@mui/material'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import PrimeTable from '../../../components/PrimeTable'
import { useState, useContext } from 'react'
import { metodoPrograma } from '../../../components/api'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { PropostaContext } from './index'
import { GlobalContext } from '../../../App'

const Itens = () => {
  const { usuarioLogado } = useContext(GlobalContext)
  const { dadosEdicao, handleSalvar, atualizaTotais, dispatch } =
    useContext(PropostaContext)
  const [reloadAtendimento, setReloadAtendimento] = useState(false)

  const salvarTipoAtendimento = async (values) => {
    const payload = {
      idAtendimento: dadosEdicao.idAtendimento,
      idTipoAtendimento: values?.acTipoAtendimento?.[0]?.[0],
      vlTotal: values?.vlTotal,
      idPacientes: (values?.acPacientes || []).map(
        (paciente) => paciente?.[0]?.[0],
      ),
    }

    const resp = await metodoPrograma('salvaTipoAtendimento', payload)
    if (resp.status) {
      setReloadAtendimento((v) => !v)
      const novosTotais = await atualizaTotais(dadosEdicao.idAtendimento)
      const dadosSalvar = {
        ...dadosEdicao,
        ...novosTotais,
      }
      await handleSalvar(dadosSalvar)
    }
  }

  const editarTipoAtendimento = async (linha, close) => {
    const payload = {
      idAtendimento: linha?.[0],
      sqItem: linha?.[1],
      idTipoAtendimento: linha?.[2][0][0],
      qtItem: linha?.[3],
      vlTotal: Number(linha?.[4] || 0),
      idPacientes: (linha?.[5] || []).map((paciente) => paciente?.[0]?.[0]),
    }
    await metodoPrograma('alteraTipoAtendimento', payload)

    const novosTotais = await atualizaTotais(linha?.[0])

    setReloadAtendimento((v) => !v)

    const dadosSalvar = {
      ...dadosEdicao,
      ...novosTotais,
    }
    await handleSalvar(dadosSalvar)

    close()
  }

  const excluiTipoAtendimento = async (values) => {
    // TODO - Verificar se é permitido excluir o item, atualmente só é permitido se o atendimento estiver em aberto, ou seja, dadosEdicao?.tpSituacao === '0'
    const payload = {
      idAtendimento: values?.[0],
      sqItem: values?.[1],
    }

    const resp = await metodoPrograma('excluiTipoAtendimento', payload)
    if (resp.status) {
      setReloadAtendimento((v) => !v)
      const novosTotais = await atualizaTotais(values?.[0])
      const dadosSalvar = {
        ...dadosEdicao,
        ...novosTotais,
      }
      await handleSalvar(dadosSalvar)
    }
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Typography variant="h5">Pacote</Typography>
          <Divider />
        </Grid>
        <Grid container spacing={2} style={{ padding: 20 }} item xs={12}>
          <Grid item container spacing={2}>
            {dadosEdicao.idAtendimento && (
              <Grid item xs={12}>
                <PrimeTable
                  action="listaTipoAtendimento"
                  codigo="CtrlProposta"
                  parametros={{ idAtendimento: dadosEdicao.idAtendimento }}
                  autocompleteEditableIndex={[0]}
                  actionResponse={(resp) =>
                    dispatch({
                      type: 'dadosEdicao',
                      field: 'listPacotes',
                      value: resp?.lista || [],
                    })
                  }
                  head={['Item', 'Pacientes', 'Valor', '', '']}
                  refresh={reloadAtendimento}
                  line={(item) => [
                    item?.[2]?.[1],
                    <Box
                      key={`pacientes-${item?.[0]}-${item?.[1]}`}
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0.5,
                      }}
                    >
                      {(item?.[5] || []).map((paciente) => (
                        <Chip
                          key={paciente?.[0]?.[0]}
                          label={paciente?.[1]}
                          size="small"
                        />
                      ))}
                    </Box>,
                    item?.[4],
                    '',
                    '',
                  ]}
                  collumnsCurrency={[2]}
                  rows={100000}
                  editButton={dadosEdicao.tpSituacao === '0'}
                  addButton={dadosEdicao.tpSituacao === '0'}
                  disablePagination
                  fastDisablePortal={false}
                  getFastAddInitialValues={() => {
                    const pacientes = dadosEdicao.listPacientes || []

                    if (pacientes.length !== 1) return {}

                    return {
                      acPacientes: [[[pacientes[0]?.[0]], pacientes[0]?.[1]]],
                    }
                  }}
                  onDelete={
                    dadosEdicao.tpSituacao === '0'
                      ? { index: 4, action: excluiTipoAtendimento }
                      : undefined
                  }
                  fastAddComponent={({ values, edit, close }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <AutoComplete
                          metodo="buscaTipoAtendimento"
                          codigo="CtrlProposta"
                          value={values?.acTipoAtendimento}
                          name="acTipoAtendimento"
                          label="Pacote"
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          size="small"
                          searchParams={{ idUsuario: usuarioLogado.id }}
                          onChange={async (_, val) => {
                            await edit({
                              value: val,
                              field: 'acTipoAtendimento',
                            })
                            await edit({
                              value: val?.[2] || 0,
                              field: 'vlTotal',
                            })
                          }}
                          textFieldProps={{
                            helperText: !values?.acTipoAtendimento
                              ? 'Campo Obrigatório!'
                              : '',
                            error: !values?.acTipoAtendimento,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <CurrencyField
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          name="vlTotal"
                          label="Valor"
                          size="small"
                          value={values?.vlTotal}
                          onChange={(v) => edit({ value: v, field: 'vlTotal' })}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <AutoComplete
                          metodo="buscaPacienteAtendimento"
                          codigo="CtrlProposta"
                          value={values?.acPacientes || []}
                          name="acPacientes"
                          label="Pacientes que utilizarão o pacote"
                          multiple
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          size="small"
                          searchParams={{
                            idAtendimento: dadosEdicao.idAtendimento,
                          }}
                          filterFunction={() => true}
                          filterSelectedOptions={false}
                          onChange={(_, val) =>
                            edit({ value: val, field: 'acPacientes' })
                          }
                          textFieldProps={{
                            helperText:
                              values?.acPacientes?.length > 0
                                ? ''
                                : 'Campo Obrigatório!',
                            error: !(values?.acPacientes?.length > 0),
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        container
                        xs={12}
                        spacing={2}
                        justifyContent="flex-end"
                      >
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={close}
                            fullWidth
                            variant="contained"
                            color="inherit"
                            style={{ margin: '5px' }}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={() =>
                              !!values?.acTipoAtendimento &&
                              values?.acPacientes?.length > 0 &&
                              salvarTipoAtendimento(values) &&
                              close()
                            }
                            variant="contained"
                            fullWidth
                            color="primary"
                            style={{ margin: '5px' }}
                          >
                            Salvar
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  fastEditComponent={({ linha, close, edit }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <AutoComplete
                          metodo="buscaTipoAtendimento"
                          codigo="CtrlProposta"
                          value={linha[2]}
                          name="acTipoAtendimento"
                          label="Terapia"
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          size="small"
                          searchParams={{ idUsuario: usuarioLogado.id }}
                          onChange={(_, val) => edit({ value: val, index: 2 })}
                          textFieldProps={{
                            helperText: !linha?.[2] ? 'Campo Obrigatório!' : '',
                            error: !linha?.[2],
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <CurrencyField
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          label="Valor"
                          size="small"
                          value={linha[4]}
                          onChange={(v) => edit({ value: v, index: 4 })}
                          helperText={!linha?.[4] ? 'Campo Obrigatório!' : ''}
                          error={!linha?.[4]}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <AutoComplete
                          metodo="buscaPacienteAtendimento"
                          codigo="CtrlProposta"
                          value={linha?.[5] || []}
                          name="acPacientes"
                          label="Pacientes que utilizarão o pacote"
                          multiple
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          size="small"
                          searchParams={{
                            idAtendimento: dadosEdicao.idAtendimento,
                          }}
                          filterFunction={() => true}
                          filterSelectedOptions={false}
                          onChange={(_, val) => edit({ value: val, index: 5 })}
                          textFieldProps={{
                            helperText:
                              linha?.[5]?.length > 0
                                ? ''
                                : 'Campo Obrigatório!',
                            error: !(linha?.[5]?.length > 0),
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        container
                        xs={12}
                        spacing={2}
                        justifyContent="flex-end"
                      >
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={close}
                            fullWidth
                            variant="contained"
                            color="inherit"
                            style={{ margin: '5px' }}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={() =>
                              !!linha?.[2] &&
                              !!linha?.[4] &&
                              linha?.[5]?.length > 0 &&
                              editarTipoAtendimento(linha, close) &&
                              close()
                            }
                            variant="contained"
                            fullWidth
                            color="primary"
                            style={{ margin: '5px' }}
                          >
                            Editar
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default Itens
